<template>
    <transition name="sui-animation--fade">
        <div class="sui-toast"
            v-if="show">{{ content }}</div>
    </transition>
</template>

<script>
    export default {
        name: 'sui-toast',
        
        data() {
            return {
                show: false, // 显示控制
                content: '', // 提示内容
            }
        }
    }
</script>

<style lang="postcss">
.sui-toast {
    z-index: 999;
    position: fixed;
    top: 50%;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    padding: 12px 18px;
    font-size: 14px;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
    transform: translate3d(-50%, -50%, 0);
}
</style>